import { UsuarioDTO } from "app/main/apps/shared/interfaces/usuario.interface";
import { tap } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { environment as ENV } from "environments/environment";

import { SucursalPersonaDTO } from "../../interfaces/sucursal-persona.interface";

import { DashboardDTO } from "../../interfaces/dashboard.interface";
import { NuevoRepresentanteDTO } from "../../models/representante.model";
import { SupervisorDTO } from "../../interfaces/supervisores.interface";

const API = "usuario/";

@Injectable({
    providedIn: "root",
})
export class UsuarioService {
    fotoChanged$: Subject<boolean>;
    supervisoresChanged$: Subject<SupervisorDTO[]>;
    private perfil: UsuarioDTO;
    private perfilSubject = new BehaviorSubject<UsuarioDTO>(null);
    perfil$ = this.perfilSubject.asObservable();
    constructor(private http: HttpClient) {
        this.fotoChanged$ = new Subject();
        this.supervisoresChanged$ = new Subject();
    }

    fetchPerfilPersona(): Promise<UsuarioDTO> {
        return this.http
            .get<UsuarioDTO>(`${ENV.apiUrl}${API}perfil`)
            .pipe(
                tap((perfil) => {
                    this.perfilSubject.next(perfil);
                    this.setPerfil(perfil);
                })
            )
            .toPromise();
    }

    fetchSucursalesPersona(): Observable<SucursalPersonaDTO[]> {
        return this.http.get<SucursalPersonaDTO[]>(
            `${ENV.apiUrl}${API}sucursales`
        );
    }

    getPerfil(): UsuarioDTO {
        return this.perfil;
    }

    setPerfil(perfil: UsuarioDTO): void {
        this.perfil = perfil;
    }

    saveCorreo(correo: string): Observable<any> {
        correo = encodeURIComponent(correo);
        return this.http.patch<any>(
            `${ENV.apiUrl}${API}email?correo=${correo}`,
            null
        );
    }

    saveClave(clave: string): Observable<any> {
        return this.http.patch<any>(`${ENV.apiUrl}${API}clave?clave=${clave}`, {
            responseType: "text",
        });
    }

    fetchDashboard(): Observable<DashboardDTO> {
        return this.http.get<DashboardDTO>(`${ENV.apiUrl}${API}dashboard`);
    }

    fetchFoto(codigo: string): Observable<Blob> {
        const requestOptions: Object = {
            responseType: "blob",
        };
        return this.http.get<any>(
            `${ENV.apiUrl}${API}fotografia/${codigo}`,
            requestOptions
        );
    }

    saveFoto(codigo: string, foto: File): Observable<any> {
        var form = new FormData();
        form.append("foto", foto, foto.name);

        return this.http.post<any>(
            `${ENV.apiUrl}${API}fotografia/${codigo}`,
            form,
            {
                reportProgress: true,
            }
        );
    }

    guardarConfiguracionNotificaciones(configuracion: number[]) {
        const requestOptions: Object = {
            responseType: "text",
        };

        return this.http.patch<any>(
            `${ENV.apiUrl}${API}notificaciones`,
            configuracion,
            requestOptions
        );
    }

    fetchSupervidores(): Observable<SupervisorDTO[]> {
        console.log(`${ENV.apiUrl}${API}supervisores`);
        return this.http.get<SupervisorDTO[]>(
            `${ENV.apiUrl}${API}supervisores`
        );
    }

    guardaSupervisor(supervisor: NuevoRepresentanteDTO): Observable<any> {
        return this.http.post<any>(
            `${ENV.apiUrl}${API}supervisores`,
            supervisor
        );
    }

    deleteSupervisor(rut: number): Observable<any> {
        const requestOptions: Object = {
            responseType: "text",
        };
        return this.http.delete(
            `${ENV.apiUrl}${API}supervisores/${rut}`,
            requestOptions
        );
    }
}
